export default __webpack_public_path__ + "static/media/1505.64fa527b.png";